import SelectHookFormSingle from "components/SelectHookFormSingle";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useGetActivePhoneSetNumber } from "../hooks/useGetActivePhoneSetNumber";
import { OFFICE_PERMISSIONS } from "../permission";

const OfficeTelecom = ({ isEditState, isAddState, disableFields }) => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const addOfficeTelecom = OFFICE_PERMISSIONS.permission_office_telecom_add;
  const editOfficeTelecom = OFFICE_PERMISSIONS.permission_office_telecom_edit;

  const formMethods = useFormContext();
  const {
    formState: { errors },
    watch,
    setValue,
  } = formMethods;
  const [isRequired, setIsRequired] = useState(false);

  const { data: activePhoneSetNumber, isLoading: psnLoading } =
    useGetActivePhoneSetNumber();
  const psnOptions = activePhoneSetNumber?.map((x) => {
    return { value: x.phoneSetNumberId, label: x.phoneSetNumber1 };
  });

  const officeType = watch("officeType");
  const currentStatus = watch("officeStatus");
  useEffect(() => {
    if (
      isEditState &&
      officeType?.includes("Retail") &&
      currentStatus === "Open" &&
      userPermissions.includes(editOfficeTelecom)
    ) {
      setIsRequired(true);
    } else {
      setIsRequired(false);
    }
  }, [isEditState, officeType, currentStatus]);

  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 pb-4">
      <div className="text-quinary font-bold font-sans py-2 px-4">Telecom</div>
      <div className="grid grid-cols-1 md:grid-cols-2 px-4 gap-12">
        <div className="space-y-1">
          <Controller
            control={formMethods.control}
            name="finessePeripheralSet"
            rules={{
              required: {
                value: isRequired,
                message: "Required Field",
              },
            }}
            render={({ field }) => {
              const selectedOption = psnOptions?.find(
                (option) => option.label === field.value
              );
              return (
                <SelectHookFormSingle
                  field={field}
                  label="Finesse Peripheral Set"
                  onChange={(e) => {
                    field.onChange(e ? e.value : 0);
                    setValue("finessePeripheralSet", e ? e.label : null);
                  }}
                  value={selectedOption ? selectedOption.value : 0}
                  isLoading={psnLoading}
                  options={psnOptions}
                  required={isRequired}
                  className={
                    errors.finessePeripheralSet &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  isDisabled={
                    disableFields ||
                    (isAddState &&
                      !userPermissions.includes(addOfficeTelecom)) ||
                    (isEditState &&
                      !userPermissions.includes(editOfficeTelecom))
                  }
                />
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OfficeTelecom;
